<div *transloco="let t; read: 'page-not-found'" class="flex justify-center items-center mt-12">
  <psc-section-title
    [title]="t('title')"
    [subtitle]="t('not-found')"
  ></psc-section-title>
</div>
